export function normalizeStudentId(value) {
  const id = String(value || "").trim().toUpperCase();
  return id && id !== "UNDEFINED" && id !== "NULL" ? id : "";
}

export function buildStudentRoute(studentId, path) {
  const id = normalizeStudentId(studentId);
  if (!id) throw new Error("Canonical student ID is required");
  return `/student/${encodeURIComponent(id)}${path.startsWith("/") ? path : `/${path}`}`;
}
